<template>
    <div class="widget-volo-hotel accordion">
        <div :class="voliHotelTourDisabled ? 'card disabled' : 'card'" id="voloAndataId">
            <div class="card-header" @click="onShow(0)">
                <div class="d-flex justify-content-between">
                    <h5>Volo andata</h5>
                    <span v-if="voloAndataTitle" v-tooltip="voloAndataTooltip">{{voloAndataTitle}}</span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(0)" class="collapse show">
                    <div class="card-body pb-0">
                        <FilterFlightPanel v-if="panels[0].showAll" :is-from="true" :is-show-flexible-dates="!isExperience" class="mb-3"/>
                        <FlightPanel ref="flightsFromRef" v-for="(item, index) in flightsFrom" :key="index" :value="item" class="mb-3" :selected="flightFrom.itemId === item.itemId" @select="onFlightFromSelect"/>
                        <ShowMore scroll-to="voloAndataId" :showAll="panels[0].showAll" :remains="counterFlightsFrom" @click="onShowMore"/>
                    </div>
                </div>
            </transition>
        </div>
        <div :class="voliHotelTourDisabled ? 'card disabled' : 'card'" id="voloRitornoId">
            <div class="card-header" @click="onShow(1)">
                <div class="d-flex justify-content-between">
                    <h5>Volo ritorno</h5>
                    <span v-if="voloRitornoTitle" v-tooltip="voloRitornoTooltip">{{voloRitornoTitle}}</span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(1)" class="collapse show">
                    <div class="card-body">
                        <FlightPanel ref="flightsToRef" v-for="(item, index) in flightsTo" :key="index" :value="item" :selected="flightTo.itemId === item.itemId" @select="onFlightToSelect"/>
                        <ShowMore scroll-to="voloRitornoId" :showAll="panels[1].showAll" :remains="counterFlightsTo" @click="(value) => {panels[1].showAll = value.open}"/>
                    </div>
                </div>
            </transition>
        </div>
        <div class="card pb-3" :class="voliHotelTourDisabled ? 'disabled' : ''" id="hotelId">
            <div class="card-header" @click="onShow(2)">
                <div class="d-flex justify-content-between">
                    <h5>Hotel</h5>
                    <span v-if="hotelTitle">{{hotelTitle}}</span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(2)" class="collapse show">
                    <div class="card-body pb-0">
                        <div v-for="(item, index) in hotelsPeriods" :key="index">
                            <HotelPanel  v-for="(hotel, index2) in item.selected" :key="index2" :value="hotel" :selected="true" @detail="onShowHotelDetail"/>
                            <div class="show-more" v-if="(item.list.length - 1) > 0">
                                <a href="javascript:void(0)" class="py-2 default-bold text-primary" @click="onOpenHotelMap(item.list)">vedi altre {{item.list.length - 1}} alternative</a>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="hasTour" :class="voliHotelTourDisabled? 'card disabled' : 'card'" id="tourId">
            <div class="card-header" @click="onShow(5)">
                <div class="d-flex justify-content-between">
                    <h5>Tour</h5>
                    <span v-if="tourTitle" v-tooltip="tourTooltip">{{tourTitle}}</span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(5)" class="collapse show">
                    <div class="card-body py-2">
                        <TourPanel :value="tour" />
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="servizi && servizi.length" :class="attivitaDisabled ? 'card disabled' : 'card'" id="serviceId">
            <div class="card-header d-flex justify-content-between" @click="() => {trackTabAttivitaTabBlu(); onShow(3)}">
                <div class="d-flex justify-content-between">
                    <h5>Attività</h5>
                    <div class="d-flex">
                        <span v-if="serviceTitle">{{serviceTitle}}</span>
                    </div>
                </div>
                <div class="plus cursor-pointer" @click="onOpenServiceMap">
                    <span class="mdi mdi-plus mdi-18px text-white"></span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(3) && serviziSelected.length > 0" class="collapse show">
                    <div class="card-body pb-0" v-if="!clearServices">
                        <ServicePanel v-for="(item, index) in serviziSelected" :key="index" :value="item" :class="index === serviziSelected.length-1 ? '' : 'mb-3'" :selected="true" :open-to-date="openToDate()" @detail="onShowServiceDetail" @remove="onRefreshServices"/>
                        <div class="show-more" v-if="(servizi.length - serviziSelected.length) > 0">
                            <a href="javascript:void(0)" class="py-2 default-bold text-primary" @click="onOpenServiceMap">vedi altre {{servizi.length - serviziSelected.length}} alternative</a>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div v-if="trasferimenti && trasferimenti.length" :class="trasferimentiDisabled ? 'card disabled' : 'card'" id="trasferimentiId">
            <div class="card-header d-flex justify-content-between" @click="() => {trackTabTraferimentiTabBlu(); onShow(4)}">
                <div class="d-flex justify-content-between">
                    <h5>Trasferimenti</h5>
                    <div class="d-flex">
                        <span v-if="trasferimentiTitle">{{trasferimentiTitle}}</span>
                    </div>
                </div>
                <div v-if="!trasferimentiAlternativeHide" class="plus cursor-pointer" @click="onOpenTrasferimentiMap">
                    <span class="mdi mdi-plus mdi-18px text-white"></span>
                </div>
            </div>
            <transition>
                <div v-if="isShow(4) && trasferimentiSelected.length > 0" class="collapse show">
                    <div class="card-body pb-0">
                        <ServicePanel :is-trasferimento="true" v-for="(item, index) in trasferimentiSelected" :key="index" :value="item" :class="index === trasferimentiSelected.length-1 ? '' : 'mb-3'" :selected="true" @detail="onShowTrasferimentoDetail"/>
                        <div v-if="!trasferimentiAlternativeHide" class="show-more">
                            <a href="javascript:void(0)" class="py-2 default-bold text-primary" @click="onOpenTrasferimentiMap">vedi altre {{trasferimentiAltreAlternativeNumber}} alternative</a>
                        </div>
                        <div v-else class="p-2">
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <CompletaPreventivo ref="componentCompletaPreventivo"/>
        <ScrollToTop/>
        <div>
            <ModalHotelsMap v-if="!isMobile" ref="modalHotelsMap" :list="hotelsList"/>
            <ModalHotelsMobileMap v-else ref="modalHotelsMap" :list="hotelsList"/>
            <ModalServicesMap v-if="!isMobile" ref="modalServicesMap" :list="servizi"/>
            <ModalServicesMobileMap v-else ref="modalServicesMap" :list="servizi"/>
            <ModalServicesMap v-if="!isMobile" :is-trasferimento="true" ref="modalTrasferimentiMap" :list="trasferimenti"/>
            <ModalServicesMobileMap v-else :is-trasferimento="true" ref="modalTrasferimentiMap" :list="trasferimenti"/>
            <ModalHotelDetail v-if="showHotelItem" ref="modalHotelDetail" :value="showHotelItem"/>
            <ModalServiceDetail v-if="showServiceItem" ref="modalServiceDetail" :value="showServiceItem" @change="onChangeServiceGroup" />
            <ModalServiceDetail v-if="showTrasferimentoItem" :is-trasferimento="true" ref="modalTrasferimentoDetail" :value="showTrasferimentoItem"/>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DefaultPanel from '../../../templates/DefaultPanel'
import FlightPanel from '../../common/FlightPanel'
import HotelPanel from './HotelPanel'
import FilterFlightPanel from './FilterFlightPanel'
import MessageNext from '../../common/MessageNext'
import FilterHotelPanel from './FilterHotelPanel'
import FilterServicePanel from '../../common/FilterServicePanel'
import ShowMore from '../../common/ShowMore'
import ServicePanel from '../../common/ServicePanel'
import {hotelName} from '../../../../utils/helper'
import {voloAndataTitle, voloAndataTooltip, voloRitornoTitle, voloRitornoTooltip} from '../../../../utils/flightUtils'
import CompletaPreventivo from '../../common/CompletaPreventivo'
import ModalCompletaPratica from '../../common/modals/ModalCompletaPratica'
import ModalHotelsMap from './modals/ModalHotelsMap'
import ModalHotelsMobileMap from './modals/ModalHotelsMobileMap'
import ModalHotelDetail from './modals/ModalHotelDetail'
import ModalServicesMap from '../../common/modals/ModalServicesMap'
import ModalServicesMobileMap from '../../common/modals/ModalServicesMobileMap'
import ModalServiceDetail from '../../common/modals/ModalServiceDetail'
import TourPanel from '../tour-accompagnati/TourPanel'
import AnalyticEvents from '../../../common/AnalyticEvents'
import MobileDetector from '../../../common/MobileDetector'
import BackofficeAction from '../../../actions/BackofficeAction'
import ScrollToTop from '../../../common/ScrollToTop'
import AliveActions from '../../../actions/AliveActions'

const LIMIT_SHOW_VOLI = 1

const initialPanels = [
  { show: true, disabled: false, showAll: false },
  { show: true, disabled: false, showAll: false },
  { show: true, disabled: false, showAll: false },
  { show: false, disabled: true, showAll: false },
  { show: false, disabled: true, showAll: false },
  { show: true, disabled: false, showAll: false }
]

export default {
  name: 'WizzardVoloHotel',
  mixins: [AnalyticEvents, MobileDetector, BackofficeAction, AliveActions],
  components: {
    ScrollToTop, TourPanel, ModalServiceDetail, ModalServicesMap, ModalServicesMobileMap, ModalHotelDetail, ModalHotelsMap, ModalHotelsMobileMap, ModalCompletaPratica, CompletaPreventivo, ServicePanel, ShowMore, FilterHotelPanel, FilterServicePanel, MessageNext, FilterFlightPanel, HotelPanel, FlightPanel, DefaultPanel},
  props: {
    isExperience: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      showServiceItem: null,
      showTrasferimentoItem: null,
      showHotelItem: null,
      hotelsList: [],
      panels: [...initialPanels],
      step: 0,
      clearServices: false
    }
  },
  computed: {
    voliHotelTourDisabled () {
      return this.step >= 3 && this.step !== 5
    },
    attivitaDisabled () {
      return this.step !== 3
    },
    trasferimentiDisabled () {
      return this.step !== 4
    },
    trasferimentiAlternativeHide () {
      return this.trasferimentiSelected.find(item => item.isTrasferimentoFisso) || this.trasferimentiAltreAlternativeNumber === 0
    },
    voloAndataTitle () {
      return voloAndataTitle(this.flightFrom)
    },
    voloAndataTooltip () {
      return voloAndataTooltip(this.flightFrom)
    },
    voloRitornoTitle () {
      return voloRitornoTitle(this.flightTo)
    },
    voloRitornoTooltip () {
      return voloRitornoTooltip(this.flightTo)
    },
    hotelTitle () {
      const names = this.hotelsPeriods.map(item => {
        return hotelName(item.selected[0].hotel.location.name)
      })
      if (names.length === 0) return ''
      return names.reduce((totale, current) => {
        return totale.concat(' - ' + current)
      })
    },
    tourTitle () {
      const tour = this.getTour()
      return tour && tour.anagrafica && tour.anagrafica.element ? tour.anagrafica.element.name : ''
    },
    tourTooltip () {
      return this.tourTitle
    },
    serviceTitle () {
      const counter = this.serviziSelected.length
      return counter === 0 ? '' : (counter === 1 ? `N° ${counter} ${this.isMobile ? '' : 'attività selezionata'}` : `N° ${counter} ${this.isMobile ? '' : 'attività selezionate'}`)
    },
    trasferimentiTitle () {
      const counter = this.trasferimentiSelected.length
      return counter === 0 ? '' : (counter === 1 ? `N° ${counter} ${this.isMobile ? '' : 'trasferimento selezionato'}` : `N° ${counter} ${this.isMobile ? '' : 'trasferimenti selezionati'}`)
    },
    flightFrom () {
      return this.getFlightFrom()
    },
    flightsFrom () {
      return this.getFlightsFrom().filter((item) => {
        return this.panels[0].showAll || this.flightFrom.itemId === item.itemId
      })
    },
    counterFlightsFrom () {
      return this.getAllFlightsFrom().length - LIMIT_SHOW_VOLI
    },
    flightTo () {
      return this.getFlightTo()
    },
    flightsTo () {
      return this.getFlightsTo().filter((item) => {
        return this.panels[1].showAll || this.flightTo.itemId === item.itemId
      })
    },
    counterFlightsTo () {
      if (this.panels[1].showAll) return 0
      return this.getFlightsTo().length - LIMIT_SHOW_VOLI
    },
    hotelsPeriods () {
      return this.getHotelPeriods()
    },
    hasTour () {
      return this.tour.detailResponses.length > 0
    },
    tour () {
      return this.getTour()
    },
    serviziSelected () {
      const list = this.getServiziSelected()
      return list
    },
    servizi () {
      return this.getListaServizi()
    },
    trasferimentiSelected () {
      const list = this.getTrasferimentiSelected()
      // ci sono al massimo sempre due trasferimenti, se sono uguali faccio vedere solo il primo
      if (list.length === 2 && list[0].detail.productID === list[1].detail.productID) {
        return [list[0]]
      }
      return list
    },
    trasferimenti () {
      return this.getListaTrasferimentiFiltered()
    },
    trasferimentiAltreAlternativeNumber () {
      const others = this.trasferimenti.length - this.trasferimentiSelected.length
      return others > 0 ? others : 0
    }
  },
  methods: {
    ...mapGetters(['getSearch', 'getTour', 'getFlightFrom', 'getFlightsFrom', 'getAllFlightsFrom', 'getFlightTo', 'getFlightsTo', 'getAllFlightsTo']),
    ...mapGetters(['getHotelPeriods', 'getTypesRating', 'getListaHotels', 'getServiziSelected']),
    ...mapGetters(['getListaServizi', 'getListaTrasferimenti', 'getServiziSelected', 'getTrasferimentiSelected']),
    ...mapActions(['updateVariableStep', 'loadingStart', 'loadingEnd', 'selectFlightFrom', 'selectFlightTo', 'loadSpeseAccessorie', 'addReplaceServizio', 'resetVariableStep']),
    /**
     * verifica se escludere o meno i non configurati
     * Si visualizzano solo i trasferimenti configurati (quelli presenti nella lista servizi in backoffice) se:
     * 1) esiste uno e uno solo hotelsPeriods
     * 2) la configurazione a Backoffice dell'hotel corrispondente non ha abbinato alcun trasferimento
     * @returns {*}
     */
    getListaTrasferimentiFiltered () {
      const list = this.getListaTrasferimenti()
      if (this.hotelsPeriods.length === 1) {
        const hotelSelected = this.hotelsPeriods[0].selected[0].hotel
        const hotelBO = this.searchBackofficeHotel(hotelSelected)
        if (hotelBO && hotelBO.codiceAndata == null && hotelBO.codiceRitorno == null) {
          return list.filter(item => item.nonConfigurato === false)
        }
      }
      return list
    },
    openToDate () {
      return this.getSearch().andata
    },
    isShow (index) {
      return this.panels[index].show
    },
    isDisabled (index) {
      return this.panels[index].disabled
    },
    isSelectedHotel (hotel) {
      const list = this.$store.getters.getSelectedHotelsByPeriod(hotel.period)
      return list.some(item => {
        return hotel.hotel.location.name === item.hotel.location.name
      })
    },
    isSelectedServizio (servizio) {
      const list = this.getServiziSelected()
      return list.some(item => {
        return servizio.detail.productID === item.detail.productID
      })
    },
    isSelectedTrasferimenti (servizio) {
      const list = this.getTrasferimentiSelected()
      return list.some(item => {
        return servizio.detail.productID === item.detail.productID
      })
    },
    onHideAll (index) {
      this.panels[index].showAll = false
      this.$scrollTo(`#app`)
    },
    onShow (index) {
      this.panels[index].show = !this.panels[index].show
      if (this.panels[index].show) {
        this.step = index
        this.updateVariableStep(index)
      }
    },
    onOpen (index) {
      this.panels[index].show = true
      this.step = index
      this.updateVariableStep(index)
    },
    onOpenPanel (event, index, scrollId) {
      event.stopPropagation()
      this.closeAllPanels()
      this.panels[index].show = true
      this.panels[index].disabled = false
      this.panels[index].showAll = false
      setTimeout(() => this.$scrollTo(`#${scrollId}`, 0, {offset: -60}), 500)
    },
    closeAllPanels () {
      this.panels.forEach(item => {
        item.show = false
      })
    },
    onFlightFromSelect (value) {
      this.selectFlightFrom(value)
      const flightToUpdated = this.getFlightsTo()
      if (flightToUpdated.length > 0) {
        this.selectFlightTo(flightToUpdated[0])
      }
      this.$refs.flightsFromRef.forEach(item => {
        item.$forceUpdate()
      })
      this.onHideAll(0)
    },
    onFlightToSelect (value) {
      this.selectFlightTo(value)
      this.$refs.flightsToRef.forEach(item => {
        item.$forceUpdate()
      })
      this.onHideAll(1)
    },
    onOpenHotelMap (list) {
      this.trackTabHotelAltreAlternative()
      this.hotelsList = list
      this.$nextTick(() => {
        this.$refs.modalHotelsMap.open()
      })
    },
    onShowHotelDetail (hotel) {
      this.showHotelItem = null
      this.$nextTick(() => {
        this.showHotelItem = hotel
        this.$nextTick(() => {
          this.$refs.modalHotelDetail.open()
        })
      })
    },
    onOpenServiceMap (event) {
      this.trackTabAttivitaMostraAlternative()
      event.stopPropagation()
      this.step = 3
      this.updateVariableStep(3)
      this.$refs.modalServicesMap.open()
      this.openTab('serviceId')
    },
    onShowServiceDetail (service) {
      this.showServiceItem = null
      this.$nextTick(() => {
        this.showServiceItem = service
        this.$nextTick(() => {
          this.$refs.modalServiceDetail.open(service.groups)
        })
      })
    },
    onRefreshServices () {
      this.clearServices = true
      this.$nextTick(() => {
        this.clearServices = false
      })
    },
    onShowTrasferimentoDetail (trasferimento) {
      this.showTrasferimentoItem = null
      this.$nextTick(() => {
        this.showTrasferimentoItem = trasferimento
        this.$nextTick(() => {
          this.$refs.modalTrasferimentoDetail.open()
        })
      })
    },
    onOpenTrasferimentiMap (event) {
      this.trackTabTraferimentiMostraAlternative()
      event.stopPropagation()
      this.step = 4
      this.updateVariableStep(4)
      this.$refs.modalTrasferimentiMap.open()
      this.openTab('trasferimentiId')
    },
    tooltip (content, width) {
      return {content, template: `<div class="tooltip ${this.type}"><div class='tooltip-inner' style="position: relative; left: -25%; min-width: ${width}px">${content}</div></div>`}
    },
    openTab (event) {
      this.closeAllPanels()
      if (event === 'initial') {
        this.onOpen(0)
        this.onOpen(1)
        this.onOpen(2)
        setTimeout(() => this.$scrollTo(`#app`), 500)
        return
      }
      if (event === 'serviceId') this.onOpen(3)
      if (event === 'trasferimentiId') this.onOpen(4)
      setTimeout(() => this.$scrollTo(`#${event}`, 300, {offset: -60}), 500)
    },
    completaPreventivo () {
      this.$refs.componentCompletaPreventivo.onCompleta()
    },
    onChangeServiceGroup (groups) {
      this.groupsSelected = groups
      const payload = {...this.showServiceItem, groups: [...this.groupsSelected]}
      this.addReplaceServizio(payload)
    },
    onShowMore (value) {
      this.trackTabVoloAltreAlternative()
      this.$store.dispatch('resetFlightFilterFrom')
      this.panels[0].showAll = value.open
    }
  },
  created () {
    this.resetVariableStep()
    this.openTab('initial')
    if (this.serviziSelected && this.serviziSelected.length > 0) {
      this.panels[3].show = true // servizi
    }
    if (this.trasferimentiSelected && this.trasferimentiSelected.length > 0) {
      this.panels[4].show = true // trasferimenti
    }
    this.pingAlive()
  },
  destroyed () {
    this.pingStop()
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/volo-hotel/WizzardVoloHotel.vue